import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);
  const touchStartX = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleTouchStart = (event) => {
      touchStartX.current = event.touches[0].clientX;
    };

    const handleTouchEnd = (event) => {
      const touchEndX = event.changedTouches[0].clientX;
      const swipeDistance = touchStartX.current - touchEndX;
      const minSwipeDistance = 50;

      if (swipeDistance > minSwipeDistance) {
        setIsMobileMenuOpen(true);
      } else if (swipeDistance < -minSwipeDistance) {
        setIsMobileMenuOpen(false);
      }
    };

    const navbarElement = navbarRef.current;
    if (navbarElement) {
      navbarElement.addEventListener("touchstart", handleTouchStart);
      navbarElement.addEventListener("touchend", handleTouchEnd);
    }

    return () => {
      if (navbarElement) {
        navbarElement.removeEventListener("touchstart", handleTouchStart);
        navbarElement.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, []);

  // Check if current path matches a link
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Check if current path is in the Profiles dropdown
  const isProfilesActive = () => {
    return [
      "/matching-profiles",
      "/selected-profiles",
      "/all-profiles",
    ].includes(location.pathname);
  };

  const hideNavbarRoutes = [
    "/login",
    "/otp-page",
    "/pending",
    "/registered",
    "/signinform",
    "/siginpreview",
    "/newacc",
    "/newotp",
    "/loginsuccessfull",
    "/rejected",
    "/usernotfound",
    "/forgotpassword",
    "/passwordreset",
    "/resetsuccessfull",
    "/registerphone",
    "/otpregister",
  ];

  if (hideNavbarRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <nav
      className="navbar"
      style={{
        backgroundColor: "white",
      }}
      ref={navbarRef}
    >
      <div className="navbar-brand">Lingayath Weds</div>
      <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
        ☰
      </button>

      <div
        className={`navbar-overlay ${isMobileMenuOpen ? "active" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      <div
        id="primary-navigation"
        className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}
      >
        <NavLink
          to="/landingpage"
          className={({ isActive }) =>
            `navbar-item ${isActive ? "active" : ""}`
          }
          end
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Home
        </NavLink>
        <div className="navbar-item dropdown" ref={dropdownRef}>
          <button
            className={`navbar-link ${isProfilesActive() ? "active" : ""}`}
            onClick={toggleDropdown}
          >
            Profiles ▼
          </button>
          {isDropdownOpen && (
            <div className={`dropdown-menu ${isDropdownOpen ? "active" : ""}`}>
              <Link
                to="/matching-profiles"
                className={`dropdown-item ${
                  isActive("/matching-profiles") ? "active" : ""
                }`}
                onClick={() => {
                  setIsDropdownOpen(false);
                  setIsMobileMenuOpen(false);
                }}
              >
                Matching Profiles
              </Link>
              <Link
                to="/selected-profiles"
                className={`dropdown-item ${
                  isActive("/selected-profiles") ? "active" : ""
                }`}
                onClick={() => {
                  setIsDropdownOpen(false);
                  setIsMobileMenuOpen(false);
                }}
              >
                Selected Profiles
              </Link>
              <Link
                to="/all-profiles"
                className={`dropdown-item ${
                  isActive("/all-profiles") ? "active" : ""
                }`}
                onClick={() => {
                  setIsDropdownOpen(false);
                  setIsMobileMenuOpen(false);
                }}
              >
                All Profiles
              </Link>
            </div>
          )}
        </div>
        <Link
          to="/my-profile"
          className={`navbar-item ${isActive("/my-profile") ? "active" : ""}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          My Profile
        </Link>
        <Link
          to="/membership-details"
          className={`navbar-item ${
            isActive("/membership-details") ? "active" : ""
          }`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Membership Details
        </Link>
        {/* <Link
  to="/notifications"
  className={`navbar-item ${isActive('/notifications') ? 'active' : ''}`}
  onClick={() => setIsMobileMenuOpen(false)}
>
  Notifications
</Link> */}

        <Link
          to="/login"
          className="navbar-item"
          onClick={(e) => {
  

  // Clear all storage
  sessionStorage.clear();
  localStorage.clear();

 

  setIsMobileMenuOpen(false);

  
  
}}
        >
          Logout
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
